module.exports = __webpack_public_path__ + "static/media/rima.37a74986.jpeg";